import type {
  Recipe,
  RecipeCreateInput,
  RecipeUpdateInput,
  RecipeKind,
} from '@/domain/entities/recipe.entity'
import type { CreateRecipeRequestDto, RecipeDto, ReplaceRecipeRequestDto } from './recipe.dto'

export const recipeMapper = {
  toRecipe(dto: RecipeDto): Recipe {
    return {
      id: dto.id,
      outletId: dto.outlet_id,
      kind: dto.kind as RecipeKind,
      targetIngredientId: dto.target_ingredient_id ?? null,
      targetIngredientName: dto.target_ingredient_name,
      name: dto.name,
      yieldQty: dto.yield_qty,
      yieldUnitId: dto.yield_unit_id,
      yieldUnitName: dto.yield_unit_name,
      active: dto.active,
      items: (dto.items ?? []).map((it) => ({
        ingredientId: it.ingredient_id,
        ingredientName: it.ingredient_name,
        qty: it.qty,
        unitId: it.unit_id,
        unitName: it.unit_name,
        qtyBase: it.qty_base,
        ord: it.ord,
      })),
    }
  },

  toCreateBody(input: RecipeCreateInput): Omit<CreateRecipeRequestDto, 'outlet_id'> {
    return {
      name: input.name,
      kind: input.kind || undefined,
      target_ingredient_id: input.targetIngredientId || undefined,
      yield_qty: input.yieldQty,
      yield_unit_id: input.yieldUnitId,
      items: input.items.map((it) => ({
        ingredient_id: it.ingredientId,
        qty: it.qty,
        unit_id: it.unitId,
      })),
    }
  },

  toUpdateBody(input: RecipeUpdateInput): ReplaceRecipeRequestDto {
    return {
      name: input.name,
      kind: input.kind || undefined,
      target_ingredient_id: input.targetIngredientId || undefined,
      yield_qty: input.yieldQty,
      yield_unit_id: input.yieldUnitId,
      active: input.active,
      items: input.items.map((it) => ({
        ingredient_id: it.ingredientId,
        qty: it.qty,
        unit_id: it.unitId,
      })),
    }
  },
}
